import { useQuery } from 'react-query'

import { getExpenseLineItemFormDataUseCase } from '@webapp/modules/expense/business-logic/use-cases/GetExpenseLineItemFormDataUseCase'
import {
  ExpenseFormReimbursementCustomizations,
  type ExpenseFormReimbursementCustomization,
} from '@webapp/modules/expense/entities/enums'
import { type RequestMileageConfiguration } from '@webapp/modules/expense/entities/RequestMileageConfiguration'
import { useGetRequestMileageConfigurationPresenter } from '@webapp/modules/expense/features/get-request-mileage-configuration'
import { expenseReportQueryConfig } from '@webapp/modules/expense/query-configs/expenseReport'

interface UseEditExpenseLineItemDrawerParams {
  requesterId: number
}

interface UseEditExpenseLineItemDrawerReturn {
  data: {
    reimbursementSetting: ExpenseFormReimbursementCustomization
    mileageConfiguration: RequestMileageConfiguration | null
  }
  states: {
    isFormDataLoading: boolean
  }
}

export const useEditExpenseLineItemDrawer = ({
  requesterId,
}: UseEditExpenseLineItemDrawerParams): UseEditExpenseLineItemDrawerReturn => {
  const { data, isLoading: isFormDataLoading } = useQuery({
    queryKey: expenseReportQueryConfig.lineItemFormData(requesterId).queryKey,
    queryFn: () =>
      getExpenseLineItemFormDataUseCase.execute({ userId: requesterId }),
  })

  const {
    data: { mileageConfiguration },
    states: { isLoading: isMileageConfigLoading },
  } = useGetRequestMileageConfigurationPresenter()

  const reimbursementSetting =
    data?.reimbursementSetting ??
    ExpenseFormReimbursementCustomizations.DEFAULT_YES

  return {
    data: {
      reimbursementSetting,
      mileageConfiguration,
    },
    states: {
      isFormDataLoading: isFormDataLoading || isMileageConfigLoading,
    },
  }
}
